import { req ,importFile} from './axiosFun';
/**
 * 商品管理
 **/
// 查看所有商品分类(分页)
export const qryCommodityList = (params) => { return req("post", "/yishantong-ui/commodity/qryCommodityList", params) };

// 修改商品分类状态
export const upCommodityStatus = (params) => { return req("post", "/yishantong-ui/commodity/upCommodityStatus", params) };

// 修改商品分类数据
export const upCommodity = (params) => { return req("post", "/yishantong-ui/commodity/upCommodity", params) };

// 新增商品分类
export const addCommodity = (params) => { return req("post", "/yishantong-ui/commodity/addCommodity", params) };



// 查看商品列表(分页)
export const qryList = (params) => { return req("post", "/yishantong-ui/commodity/qryList", params) };

// 修改商品上下架
export const upStatus = (params) => { return req("post", "/yishantong-ui/commodity/upStatusCommodity", params) };

// 修改商品数据
export const upShop = (params) => { return req("post", "/yishantong-ui/commodity/upShop", params) };

// 新增商品
export const addShop = (params) => { return req("post", "/yishantong-ui/commodity/addShop", params) };
export const delShop = (params) => { return req("post", "/yishantong-ui/commodity/delShop", params) };







// WEBPACK FOOTER //
// ./src/api/lotteryApi.js